import { marker } from '@biesbjerg/ngx-translate-extract-marker'

export const RegexEMAIL: RegExp = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
export const RegexNome: RegExp = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/i;
export const RegexNomesComuns: RegExp = /^(?=.*\S)[\p{L}\p{N}\s\-ºª;,\.]+$/u;
export const REGEX_SOMENTE_LETRAS: RegExp = /^[ a-zA-Z á]*$/i;
export const TENANT_KEY: string = "tenant";
export const LOCALE_KEY: string = "locale";
export const TIMEZONE_KEY: string = "timezone";
export const FILTER: string = "filter";
export const NOME_CONTA_KEY: string = "nome_conta";
export const TENANT_SCHEMA: string = "tenant_schema";
export const X_ORIGIN: string = "x-origin";
export const X_ORIGIN_VALUE: string = "876946d8";
export const REGEX_URL_VALIDA: RegExp = /^(http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/
export const RegexSemArroba: RegExp = /^[0-9A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ!?*%$ ]+$/i;
export const HABILITAR_SITUATOR_ZONAS = "habilitar_situator_zonas";
export const HASH_MFA: string = 'hashMfa';
export const BASIC_WEB_AUTH = "Basic Y2VudGVyLXdlYjphcGktc2VjcmV0";
export const AUTH_CLIENT_WEB = "web";
export const HEADER_TRACE_TOKEN = "X-Trace-Token";
export const HEADER_CHALLENGE_TOKEN = "X-Challenge-Token";
export const DATA_TABLE_TRANSLATIONS = {
    headerReload: '',
    headerColumnSelector: '',
    headerColumnSelectorAdded: '',
    headerColumnSelectorRemoved: '',
    indexColumn: '',
    selectColumn: '',
    selectRow: '',
    selectAllRows: '',
    expandColumn: '',
    expandRow: '',
    sortedAscending: '',
    sortedDescending: '',
    sortAscending: '',
    sortDescending: '',
    paginationLimit: marker('Registros por página'),
    paginationText: '{total} '+marker('total')+'.',
    paginationTotalPages: marker('de '),
    firstPage: '',
    prevPage: '',
    pageNumberLabel: marker('Página'),
    pageNumber: '',
    pageNumberNofM: '',
    nextPage: '',
    lastPage: '',
    loadingText: '',
    loadedText: '',
    emptyMessage: marker('Nenhum registro encontrado'),
  };

export function removerAcentos(value: string): string {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export const POSTAL_CODES_REGEX = {
  BR: /^\\d{5}-\\d{3}$/,
  MX: /^\\d{5}$/,
}

export function getPostalCodeRegex(value: string): RegExp {
  return POSTAL_CODES_REGEX[value];
}
